<template>
    <div class="copybook-result2">
        <ul>
            <li class="svg"
                :style="{background: `url(/static/img/bg${options.types}${options.color}.jpg)`}"
                v-for="n in paths.length" v-html="getHtml(n - 1)"></li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        types: '',
                        color: '2',
                        typez: 'zi',
                        blank: '0'
                    }
                }
            },
            text: {
                type: String,
                default: ''
            },
            input: {
                type: String,
                default: ''
            },
            paths: {
                type: Object,
                default: function () {
                    return []
                }
            }
        },
        methods: {
            getHtml(num) {
                let html = `<svg width="54" height="54" version="1.1" 
                    xmlns="http://www.w3.org/2000/svg">`
                for (let i = 0; i <= num; i++) {
                    let style = 'fill: #333; stroke: #333;'
                    html += `<path d="${this.paths[i]}" style="${style}" stroke-width="1.5"></path>`
                }
                html += '</svg>'
                return html
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/var";

    .copybook-result2 {
        width: 938px;
        margin: 0 auto;
        padding-left: 2px;
        @include clearfix;
        li {
            float: left;
            width: 80px;
            height: 80px;
            font-family: 'KaiTi', 'KaiTi_GB2312';
            font-size: 58px;
            text-align: center;
            line-height: 80px;
            background: url('/static/img/bg2.jpg');
            margin: 4px 0px 5px -2px;
            color: #b8b8b8;
            .bold {
                color: #000;
            }
            svg {
                margin: 16px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/stroke/index.vue